import React from 'react';

function RedirectToHtml({ url }) {
    window.location.replace(url);
    return null; // No need to render anything
}

export default RedirectToHtml;
